const formatDatetime = string => {
  if (string.length === 10) 
    return string.split('-').reverse().join('/')

  const date = new Date(string)
  return date.toLocaleString()
}

export function Filter({ label, key, type = 'default', table, valueFormatter }) {
  const _label = label
  const _key = key
  this.type = type
  this.valueFormatter = valueFormatter

  Object.defineProperties(this, {
    key: { get: () => { return _key } },
    label: { get: () => { return _label } }
  })

  this.errors = []

  ;['label', 'key'].forEach(key => {
    if (!this[key] || this[key].length === 0)
      this.errors.push(`Must pass the ${key}`)
  })

  if (this.errors.length > 0)
    throw this.errors.join('. ')

  if (Array.isArray(table))
    this.table = parseArray(table)
  else if (table)
    this.table = parseObject(table || {})

  ;['forEach', 'map', 'filter'].forEach(key => {
    this[key] = (callback) => {
      this.table[key](value => callback(value))
    }
  })

  this.valueFormatted = value => {
    if (typeof this.valueFormatter === 'function') {
      return this.valueFormatter(value)
    } else if (this.type === 'date') {
      return formatDatetime(value)
    } else if (this.type === 'input') {
      return value
    } else
      return this.table.find(o => o.value === value)?.label || ''
  }
}

function parseArray(array) {
  return array.map(v => {
    if (typeof v === 'string')
      return { label: v, value: v }
    else if (Array.isArray(v))
      return { label: v[0], value: v[1]}
    else if (v) {
      return { label: v.label, value: v.value }
    }
  })
}

function parseObject(object) {
  return Object.entries(object).map(([key, value]) => ({ label: key, value: value }))
}
